import Call from '../Call.v2';

const AdkDomains = {
    get: () => Call(`adk/domains`),
    update: (entity) => Call(`adk/domains/${entity.id}`, "PUT", { entity }),
};

export default AdkDomains;



// WEBPACK FOOTER //
// ./src/services/API/components/AdkDomains.js